(function() {
  function buildConfirmDialog() {
    var core = {};
    var root = null;
    var card = null;
    var titleEl = null;
    var linesEl = null;
    var textEl = null;
    var yesEl = null;
    var guideEl = null;
    var closeEl = null;
    var opts = null;
    var returnFocus = null;

    function makeEl(tag, className) {
      var e = document.createElement(tag);
      if (className) e.className = className;
      return e;
    }

    function attachLineGuide(li, text, guideFn) {
      li.className = 'SizeChartConfirm__line--guided';
      var span = document.createElement('span');
      span.textContent = text;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'SizeChartConfirm__lineguide';
      btn.textContent = 'Size guide';
      btn.setAttribute('aria-label', 'Size guide for ' + text);
      btn.addEventListener('click', function () {
        core.close(false);
        guideFn();
      });
      li.appendChild(span);
      li.appendChild(btn);
    }

    function focusableCardButtons() {
      var buttons = card.querySelectorAll('button');
      var out = [];
      for (var i = 0; i < buttons.length; i++) {
        var b = buttons[i];
        if (b.hidden || b.disabled) continue;
        if (b.closest('[hidden]')) continue;
        out.push(b);
      }
      return out;
    }

    function buildDom() {
      var existing = document.querySelector('[data-sizechart-confirm]');
      if (existing && existing.querySelector('.SizeChartConfirm__card') && existing.querySelector('[data-sizechart-confirm-yes]') && existing.querySelector('[data-sizechart-confirm-guide]') && existing.querySelector('[data-sizechart-confirm-close]')) {
        root = existing;
        card = existing.querySelector('.SizeChartConfirm__card');
        titleEl = card.querySelector('.SizeChartConfirm__title');
        textEl = card.querySelector('.SizeChartConfirm__text');
        yesEl = existing.querySelector('[data-sizechart-confirm-yes]');
        guideEl = existing.querySelector('[data-sizechart-confirm-guide]');
        closeEl = existing.querySelector('[data-sizechart-confirm-close]');
        linesEl = existing.querySelector('[data-sizechart-confirm-lines]');
        if (!linesEl) {
          linesEl = makeEl('ul', 'SizeChartConfirm__lines');
          linesEl.id = 'SizeChartConfirmLines';
          linesEl.setAttribute('data-sizechart-confirm-lines', '');
          linesEl.setAttribute('hidden', '');
          card.insertBefore(linesEl, textEl);
        }
        return;
      }

      root = makeEl('div', 'SizeChartConfirm');
      root.setAttribute('data-sizechart-confirm', '');
      root.setAttribute('hidden', '');

      var backdrop = makeEl('div', 'SizeChartConfirm__backdrop');
      backdrop.setAttribute('data-sizechart-confirm-backdrop', '');

      card = makeEl('div', 'SizeChartConfirm__card');
      card.setAttribute('role', 'alertdialog');
      card.setAttribute('aria-modal', 'true');
      card.setAttribute('aria-labelledby', 'SizeChartConfirmTitle');
      card.setAttribute('aria-describedby', 'SizeChartConfirmText');

      closeEl = makeEl('button', 'SizeChartConfirm__close');
      closeEl.setAttribute('type', 'button');
      closeEl.setAttribute('aria-label', 'Close');
      closeEl.setAttribute('data-sizechart-confirm-close', '');

      var svgNs = 'http://www.w3.org/2000/svg';
      var closeSvg = document.createElementNS(svgNs, 'svg');
      closeSvg.setAttribute('width', '16');
      closeSvg.setAttribute('height', '16');
      closeSvg.setAttribute('viewBox', '0 0 16 16');
      closeSvg.setAttribute('aria-hidden', 'true');
      var lineA = document.createElementNS(svgNs, 'line');
      lineA.setAttribute('x1', '2');
      lineA.setAttribute('y1', '2');
      lineA.setAttribute('x2', '14');
      lineA.setAttribute('y2', '14');
      lineA.setAttribute('stroke', 'currentColor');
      lineA.setAttribute('stroke-width', '1.5');
      var lineB = document.createElementNS(svgNs, 'line');
      lineB.setAttribute('x1', '14');
      lineB.setAttribute('y1', '2');
      lineB.setAttribute('x2', '2');
      lineB.setAttribute('y2', '14');
      lineB.setAttribute('stroke', 'currentColor');
      lineB.setAttribute('stroke-width', '1.5');
      closeSvg.appendChild(lineA);
      closeSvg.appendChild(lineB);
      closeEl.appendChild(closeSvg);

      titleEl = makeEl('h2', 'SizeChartConfirm__title');
      titleEl.id = 'SizeChartConfirmTitle';

      linesEl = makeEl('ul', 'SizeChartConfirm__lines');
      linesEl.id = 'SizeChartConfirmLines';
      linesEl.setAttribute('data-sizechart-confirm-lines', '');
      linesEl.setAttribute('hidden', '');

      textEl = makeEl('p', 'SizeChartConfirm__text');
      textEl.id = 'SizeChartConfirmText';
      textEl.textContent = "Double-check the size guide. We can't edit orders once they go into production.";

      var actions = makeEl('div', 'SizeChartConfirm__actions');

      yesEl = makeEl('button', 'SizeChartConfirm__yes');
      yesEl.setAttribute('type', 'button');
      yesEl.setAttribute('data-sizechart-confirm-yes', '');

      guideEl = makeEl('button', 'SizeChartConfirm__guide');
      guideEl.setAttribute('type', 'button');
      guideEl.setAttribute('data-sizechart-confirm-guide', '');
      guideEl.textContent = 'Open the size guide';

      actions.appendChild(yesEl);
      actions.appendChild(guideEl);

      card.appendChild(closeEl);
      card.appendChild(titleEl);
      card.appendChild(linesEl);
      card.appendChild(textEl);
      card.appendChild(actions);

      root.appendChild(backdrop);
      root.appendChild(card);

      document.body.appendChild(root);

      yesEl.addEventListener('click', function() { core.confirm(); });
      guideEl.addEventListener('click', function() { core.guide(); });
      closeEl.addEventListener('click', function() { core.close(true); });
      backdrop.addEventListener('click', function() { core.close(true); });

      document.addEventListener('keydown', function(e) {
        if (root.hasAttribute('hidden')) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          core.close(true);
          return;
        }
        if (e.key === 'Tab') {
          var focusables = focusableCardButtons();
          if (!focusables.length) return;
          var last = focusables.length - 1;
          var insideCard = card.contains(document.activeElement);
          if (e.shiftKey) {
            if (document.activeElement === focusables[0] || !insideCard) {
              e.preventDefault();
              focusables[last].focus();
            }
          } else {
            if (document.activeElement === focusables[last] || !insideCard) {
              e.preventDefault();
              focusables[0].focus();
            }
          }
        }
      });
    }

    core.ready = function() {
      if (!root) buildDom();
      return getComputedStyle(root).position === 'fixed';
    };

    core.isOpen = function() {
      return !!root && !root.hasAttribute('hidden');
    };

    core.open = function(o) {
      if (!root) buildDom();
      opts = o;
      titleEl.textContent = opts.title;

      while (linesEl.firstChild) linesEl.removeChild(linesEl.firstChild);
      var lineEntries = opts.lines || [];
      var added = 0;
      for (var i = 0; i < lineEntries.length; i++) {
        var entry = lineEntries[i];
        if (!entry) continue;
        var li = document.createElement('li');
        if (typeof entry === 'object' && typeof entry.guide === 'function') {
          attachLineGuide(li, entry.text, entry.guide);
        } else {
          li.textContent = (typeof entry === 'object') ? entry.text : entry;
        }
        linesEl.appendChild(li);
        added++;
      }
      if (added > 0) {
        linesEl.removeAttribute('hidden');
        card.setAttribute('aria-describedby', 'SizeChartConfirmLines SizeChartConfirmText');
      } else {
        linesEl.setAttribute('hidden', '');
        card.setAttribute('aria-describedby', 'SizeChartConfirmText');
      }

      yesEl.textContent = opts.confirmLabel;
      guideEl.hidden = typeof opts.onGuide !== 'function';

      var active = document.activeElement;
      if (active && active.isConnected && (active.tagName === 'BUTTON' || (active.tagName === 'INPUT' && active.type === 'submit')) && !root.contains(active)) {
        returnFocus = active;
      } else {
        returnFocus = opts.returnFocus;
      }

      root.removeAttribute('hidden');
      document.documentElement.classList.add('sizechart-confirm-locked');
      try { yesEl.focus({ preventScroll: true }); } catch (_) { yesEl.focus(); }
    };

    core.close = function(restore) {
      root.setAttribute('hidden', '');
      document.documentElement.classList.remove('sizechart-confirm-locked');
      if (restore) {
        var target = returnFocus || (opts && opts.returnFocus);
        if (target && target.isConnected) {
          try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); }
        }
      }
    };

    core.confirm = function() {
      var o = opts;
      core.close(false);
      o.onConfirm();
    };

    core.guide = function() {
      var o = opts;
      core.close(false);
      if (typeof o.onGuide === 'function') o.onGuide();
    };

    return core;
  }

  function buildSizeConfirm(core) {
    var api = { passing: false };

    api.ready = function() {
      return core.ready();
    };

    api.close = function(restore) {
      core.close(restore);
    };

    api.open = function(c) {
      var size = readSelectedSize(c.form);
      var title = size ? 'Last check: size ' + size : 'Last check before we make it';
      var confirmLabel = size ? 'Yes, add ' + size + ' to cart' : 'Yes, add to cart';

      core.open({
        title: title,
        lines: [],
        confirmLabel: confirmLabel,
        onConfirm: function() { api.confirm(c); },
        onGuide: function() { api.openGuide(c); },
        returnFocus: c.button
      });
    };

    api.confirm = function(c) {
      var btn = null;
      if (c.button && c.button.isConnected && (c.form.contains(c.button) || c.button.form === c.form)) {
        btn = c.button;
      } else {
        btn = c.form.querySelector('button[type="submit"], input[type="submit"], [name="add"], .product-form__submit, .add-to-cart');
      }

      api.passing = true;
      try {
        if (btn) {
          btn.click();
        } else if (c.form.requestSubmit) {
          c.form.requestSubmit();
        }
      } finally {
        api.passing = false;
      }
    };

    api.openGuide = function(c) {
      var host = document.querySelector('[data-pdlsg-root][data-mode="product"]');
      var trigger = host && host.querySelector('[data-pdlsg-trigger]');

      if (host && host.__pdlsg && host.__pdlsg.chart && trigger) {
        trigger.click();
        return;
      }

      var link = c.wrapper.querySelector('.SizeChartCheckbox__link');
      if (link && link.getAttribute('href')) {
        window.location.assign(link.getAttribute('href'));
      } else {
        try { c.button.focus({ preventScroll: true }); } catch (_) { c.button.focus(); }
      }
    };

    return api;
  }
  function ownTextOf(node) {
    var out = '';
    for (var i = 0; i < node.childNodes.length; i++) {
      if (node.childNodes[i].nodeType === 3) out += node.childNodes[i].nodeValue;
    }
    return out;
  }

  function collapseWhitespace(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  function optionName(radio) {
    var fs = radio.closest('fieldset');
    if (fs) {
      var legend = fs.querySelector('legend');
      if (legend) {
        var legendText = ownTextOf(legend).trim();
        if (legendText) return legendText;
      }
      var fsName = fs.getAttribute('name');
      if (fsName) return fsName;
    }
    return radio.getAttribute('name') || '';
  }

  function scanControlsForSize(list) {
    for (var i = 0; i < list.length; i++) {
      var control = list[i];
      var name = '';
      var value = '';
      if (control.tagName === 'INPUT' && control.type === 'radio' && control.hasAttribute('data-variant-input') && control.checked) {
        name = optionName(control);
        value = control.value;
      } else if (control.tagName === 'SELECT' && control.getAttribute('name') !== 'id' && control.hasAttribute('data-product-select')) {
        var label = control.id ? document.querySelector('label[for="' + control.id + '"]') : null;
        if (!label) {
          var wrap = control.closest('.variant-wrapper');
          if (wrap) label = wrap.querySelector('.variant__label');
        }
        name = label ? ownTextOf(label) : '';
        value = control.value;
      } else {
        continue;
      }
      if (/size/i.test(name)) return value;
    }
    return null;
  }

  function readSelectedSize(form) {
    var elements = Array.prototype.slice.call(form.elements);
    var result = scanControlsForSize(elements);
    if (result !== null) return collapseWhitespace(result);

    var scope = form.closest('.shopify-section') || document;
    var fallback = Array.prototype.slice.call(scope.querySelectorAll('input[data-variant-input]:checked, select[data-product-select]'));
    result = scanControlsForSize(fallback);
    if (result !== null) return collapseWhitespace(result);

    return '';
  }

  var sizeConfirmCore = window.PedalSizeConfirm || (window.PedalSizeConfirm = buildConfirmDialog());
  var sizeConfirm = window.PedalSizeChartConfirm || (window.PedalSizeChartConfirm = buildSizeConfirm(sizeConfirmCore));


  function initSizeChartCheckboxes() {
    var wrappers = document.querySelectorAll('[data-sizechart-checkbox-wrapper]');
    
    wrappers.forEach(function(wrapper) {
      if (wrapper.dataset.sizechartInitialized) return;
      wrapper.dataset.sizechartInitialized = 'true';

      var checkbox = wrapper.querySelector('[data-sizechart-checkbox]');
      if (!checkbox) return;

      var errorEl = wrapper.querySelector('[data-sizechart-error]');

      var form = wrapper.closest('form');
      if (!form) return;

      // Helper to find the active submit button
      function getSubmitButton() {
        // Broad selector to catch standard buttons and special app buttons
        return form.querySelector('button[type="submit"], input[type="submit"], [name="add"], .product-form__submit, .add-to-cart');
      }

      function showError() {
        wrapper.classList.add('SizeChartCheckbox--error');
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.classList.add('SizeChartCheckbox__error--shake');
          setTimeout(function() {
            errorEl.classList.remove('SizeChartCheckbox__error--shake');
          }, 600);
        }
      }

      function clearError() {
        wrapper.classList.remove('SizeChartCheckbox--error');
        if (errorEl) errorEl.hidden = true;
      }

      // 1. EVENT INTERCEPTION (Capture Phase)
      // This is the "Nuclear Option" to stop the Preorder app from submitting even if it replaces the button event listeners.
      form.addEventListener('click', function(e) {
        var target = e.target;
        // Check if the clicked element is a submit button or inside one
        var btn = target.closest('button[type="submit"], input[type="submit"], [name="add"], .product-form__submit, .add-to-cart');

        // If click is on a submit button (and not some other button) and checkbox is unchecked
        if (btn && !checkbox.checked) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          showError();
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });

          // Focus the checkbox so keyboard users land on the gating control
          try { checkbox.focus({ preventScroll: true }); } catch (_) { checkbox.focus(); }
          return false;
        } else if (btn && checkbox.checked) {
          if (sizeConfirm.passing) return;
          if (!sizeConfirm.ready()) return;

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          sizeConfirm.open({ form: form, checkbox: checkbox, wrapper: wrapper, button: btn });
          return false;
        }
      }, true); // <--- TRUE checks for capture phase

      form.addEventListener('submit', function(e) {
        if (!checkbox.checked) return;
        if (sizeConfirm.passing) return;

        var sub = e.submitter || null;
        if (sub && !sub.matches('button[type="submit"], input[type="submit"], [name="add"], .product-form__submit, .add-to-cart')) return;

        if (!sizeConfirm.ready()) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        sizeConfirm.open({ form: form, checkbox: checkbox, wrapper: wrapper, button: sub || getSubmitButton() });
      }, true);

      // 2. VISUAL STATE MANAGEMENT
      // The button only LOOKS disabled (opacity + cursor). It must remain
      // clickable so the capture-phase handler above can fire and surface
      // the required-text warning. A real disabled button swallows the
      // click event in every browser, which would leave users staring at
      // a greyed-out button with no explanation.
      function lockButtonStyles(btn) {
        if (!btn) return;

        if (!checkbox.checked) {
          btn.style.opacity = '0.5';
          btn.style.cursor = 'not-allowed';
          btn.setAttribute('data-sizechart-locked', 'true');
        } else {
          btn.style.opacity = '';
          btn.style.cursor = '';
          btn.removeAttribute('data-sizechart-locked');
        }
      }

      // Update on checkbox change
      checkbox.addEventListener('change', function() {
        var btn = getSubmitButton();
        lockButtonStyles(btn);
        if (checkbox.checked) clearError();
      });

      // Initial check
      var initialBtn = getSubmitButton();
      if (initialBtn) lockButtonStyles(initialBtn);

      // 3. MUTATION OBSERVER
      // Watch for Preorder app shenanigans (replacing button, removing disabled attr)
      var observer = new MutationObserver(function(mutations) {
        var btn = getSubmitButton();
        if (btn && !checkbox.checked && !btn.hasAttribute('data-sizechart-locked')) {
          lockButtonStyles(btn);
        }
      });

      observer.observe(form, { 
        childList: true, // In case button is replaced
        subtree: true, 
        attributes: true, // In case disabled attribute is removed
        attributeFilter: ['disabled', 'class', 'style'] 
      });
      
    });
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeChartCheckboxes);
  } else {
    initSizeChartCheckboxes();
  }
  
  // Re-run for dynamic sections (Shopify customizer, etc)
  document.addEventListener('shopify:section:load', initSizeChartCheckboxes);
})();
